__turbopack_context__.v({
  "className": "wXOLsq_className",
  "variable": "wXOLsq_variable",
});
